/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const FacebookMessengerSvg = () => (

  <svg width="1.1em" height="1.1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M12.2423 0.0463943C5.76338 0.0463943 0.742188 4.79223 0.742188 11.2018C0.742188 14.5546 2.11665 17.4516 4.35421 19.4532C4.54163 19.6221 4.65501 19.8558 4.66427 20.108L4.72675 22.1535C4.74757 22.806 5.42092 23.2295 6.01791 22.968L8.29943 21.9615C8.4938 21.8758 8.70899 21.8596 8.91261 21.9152C9.96082 22.2044 11.0784 22.3571 12.2423 22.3571C18.7213 22.3571 23.7425 17.6113 23.7425 11.2018C23.7425 4.79223 18.7213 0.0463943 12.2423 0.0463943Z"
      fill="#008FFF"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M5.33764 14.4644L8.71595 9.10537C9.25278 8.25385 10.4051 8.04097 11.2103 8.6449L13.8968 10.6603C14.1444 10.8454 14.4822 10.8431 14.7275 10.658L18.3557 7.90445C18.8393 7.53653 19.4733 8.11733 19.1471 8.63101L15.7711 13.9877C15.2342 14.8392 14.0819 15.0521 13.2767 14.4482L10.5902 12.4328C10.3426 12.2477 10.0048 12.25 9.75953 12.4351L6.129 15.191C5.64539 15.5589 5.01138 14.9781 5.33764 14.4644Z"
      fill="white"/>
    <defs>
      <linearGradient id="paint0_linear_311_18621" x1="12.2423" y1="0.0463943" x2="12.2423" y2="23.0467" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00B2FF"/>
        <stop offset="1" stopColor="#006AFF"/>
      </linearGradient>
    </defs>
  </svg>

);

export const FacebookMessengerIcon = (props) => (
  <Icon component={FacebookMessengerSvg} {...props} />
);

